module.exports = "https://99designs-start-assets.imgix.net/js/dcb580a8b1e826cfa23f17ba8069cce5.svg";